// axiosClient.js
import axios from 'axios';
import config from '../config';

const APPLICATION_ID = config.APPLICATION_ID || 'application-id';

let lastCapturedPageUrl = null;

const axiosClient = axios.create({
  //   baseURL: config.API_BASE_URL,
  withCredentials: true,
  headers: {
    'X-Application-Id': APPLICATION_ID,
  },
});

axiosClient.interceptors.request.use(
  (requestConfig) => {
    if (typeof window !== 'undefined') {
      const currentPageUrl = window.location.href;

      const shouldCapture =
        requestConfig.attribution === true || currentPageUrl !== lastCapturedPageUrl;

      if (shouldCapture) {
        requestConfig.headers['X-Page-Url'] = currentPageUrl;
        lastCapturedPageUrl = currentPageUrl;
      }

      delete requestConfig.attribution;
    }
    return requestConfig;
  },
  (error) => Promise.reject(error),
);

export default axiosClient;
